import { render, staticRenderFns } from "./InfotomapExcel.vue?vue&type=template&id=5b84f4d8&scoped=true&"
import script from "./InfotomapExcel.vue?vue&type=script&lang=js&"
export * from "./InfotomapExcel.vue?vue&type=script&lang=js&"
import style0 from "./InfotomapExcel.vue?vue&type=style&index=0&id=5b84f4d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b84f4d8",
  null
  
)

export default component.exports